module.exports = __webpack_public_path__ + "static/media/sign_in_background@2x.b95bd370.png";